import { useContext, useEffect } from 'react';

import { Box, HStack, VStack } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import style from './Steps.style';
import { IRenderSteps } from './Steps.type';

import { Link, Text, Icon } from '@/components';
import { PARENT_ROUTE_MAPPING_FOR_HIGHLIGHTING_IN_SIDEBAR } from '@/constants/portalRoute';
import { DashboardContext } from '@/providers/DashboardContext';
import colors from '@/styles/themes/brand/colors';
import FontSizes from '@/styles/themes/brand/fontSizes';
import FontWeights from '@/styles/themes/brand/fontWeights';

const Steps = (props: IRenderSteps) => {
  const {
    steps,
    handleToggleMenu,
    currentSelected,
    setCurrentSelected,
    title,
  } = props;
  const { stageStatusMapping } = useContext(DashboardContext);
  const router = useRouter();

  useEffect(() => {
    const findActiveIndex = steps?.findIndex(step => step.isCurrentStage);
    setCurrentSelected(findActiveIndex);
  }, [steps]);

  useEffect(() => {
    const path = router.asPath;
    let findCurrentSelectedStep = steps?.findIndex(step =>
      path.startsWith(step.slug)
    );
    if (findCurrentSelectedStep < 0) {
      findCurrentSelectedStep = steps?.findIndex(
        step =>
          step.slug ===
          PARENT_ROUTE_MAPPING_FOR_HIGHLIGHTING_IN_SIDEBAR[router.pathname]
      );
    }
    setCurrentSelected(findCurrentSelectedStep);
  }, [steps, router.asPath]);

  const handleChangeIndex = (index: number) => {
    handleToggleMenu();
    setCurrentSelected(index);
  };
  return (
    <Box mt="32px" px="22px">
      <Text sx={{ color: colors.primary, fontWeight: FontWeights.bold }}>
        {title}
      </Text>
      <Box mt="32px">
        <VStack>
          {steps?.map((step, index: number) => {
            let iconColor: string = colors.brand.secondary;

            let textColor: string = 'black';

            const isStageCompleted = stageStatusMapping[step.slug]
              ? stageStatusMapping[step.slug].isCompleteStage
              : false;
            const isCurrentStage = stageStatusMapping[step.slug]
              ? stageStatusMapping[step.slug].isCurrentStage
              : false;
            const isCurrentSelected = index === currentSelected;

            if (isStageCompleted) {
              iconColor = '#9D9D9D';
              textColor = '#9D9D9D';
            }

            if (isCurrentSelected) {
              iconColor = 'black';
              textColor = 'black';
            }
            if (isCurrentStage) {
              iconColor = colors.success;
              textColor = 'black';
            }

            return (
              <Link href={step.slug} key={index} sx={style.linkContainer}>
                <HStack
                  onClick={() => handleChangeIndex(index)}
                  sx={style.stepContainer}
                >
                  {step.icon && (
                    <Box
                      sx={{
                        background: 'white',
                        _ltr: {
                          left: '0',
                          padding: isStageCompleted
                            ? '2.5px 0px 0px 2.5px'
                            : '6px',
                        },
                        _rtl: {
                          right: '0',
                          padding: isStageCompleted ? '2px 0px 0px 2px' : '6px',
                        },
                        top: '-2',
                        color: iconColor,
                        border: ' 1px solid #1A25501A',
                        borderRadius: '50%',
                        zIndex: 1,
                      }}
                    >
                      <Icon
                        name={isStageCompleted ? 'confirmTickStep' : step.icon}
                        sx={
                          !isStageCompleted
                            ? style.stepIcon
                            : style.stepCompletedIcon
                        }
                      />
                    </Box>
                  )}
                  <Text
                    as={'span'}
                    sx={{
                      fontsize: FontSizes.normal,
                      fontWeight: isCurrentSelected
                        ? FontWeights.bold
                        : FontWeights.normal,
                      color: textColor,
                      flex: 1,
                      w: '100%',
                    }}
                  >
                    {step.name}
                  </Text>
                </HStack>
              </Link>
            );
          })}
        </VStack>
      </Box>
    </Box>
  );
};
export default Steps;

// import { useContext, useEffect } from 'react';

// import { Box, HStack, VStack } from '@chakra-ui/react';
// import { useRouter } from 'next/router';

// import style from './Steps.style';
// import { IRenderSteps } from './Steps.type';

// import { Link, Text, Icon } from '@/components';
// import { PARENT_ROUTE_MAPPING_FOR_HIGHLIGHTING_IN_SIDEBAR } from '@/constants/portalRoute';
// import { DashboardContext } from '@/providers/DashboardContext';
// import colors from '@/styles/themes/brand/colors';
// import FontSizes from '@/styles/themes/brand/fontSizes';
// import FontWeights from '@/styles/themes/brand/fontWeights';

// const Steps = (props: IRenderSteps) => {
//   const {
//     steps,
//     handleToggleMenu,
//     currentSelected,
//     setCurrentSelected,
//     title,
//   } = props;
//   const { stageStatusMapping } = useContext(DashboardContext);
//   const router = useRouter();

//   useEffect(() => {
//     const findActiveIndex = steps?.findIndex(step => step.isCurrentStage);
//     setCurrentSelected(findActiveIndex);
//   }, [steps]);

//   useEffect(() => {
//     const path = router.asPath;
//     let findCurrentSelectedStep = steps?.findIndex(step =>
//       path.startsWith(step.slug)
//     );
//     if (findCurrentSelectedStep < 0) {
//       findCurrentSelectedStep = steps?.findIndex(
//         step =>
//           step.slug ===
//           PARENT_ROUTE_MAPPING_FOR_HIGHLIGHTING_IN_SIDEBAR[router.pathname]
//       );
//     }
//     setCurrentSelected(findCurrentSelectedStep);
//   }, [steps, router.asPath]);

//   const handleChangeIndex = (index: number) => {
//     handleToggleMenu();
//     setCurrentSelected(index);
//   };
//   return (
//     <Box mt="32px" px="22px">
//       <Text sx={{ color: colors.primary, fontWeight: FontWeights.bold }}>
//         {title}
//       </Text>
//       <Box mt="32px">
//         <VStack>
//           {steps?.map((step, index: number) => {
//             let iconColor: string = colors.brand.secondary;

//             let textColor: string = 'black';

//             const isStageCompleted = stageStatusMapping[step.slug]
//               ? stageStatusMapping[step.slug].isCompleteStage
//               : false;
//             const isCurrentStage = stageStatusMapping[step.slug]
//               ? stageStatusMapping[step.slug].isCurrentStage
//               : false;
//             const isCurrentSelected = index === currentSelected;

//             if (isStageCompleted) {
//               iconColor = '#9D9D9D';
//               textColor = '#9D9D9D';
//             }

//             if (isCurrentSelected) {
//               iconColor = 'black';
//               textColor = 'black';
//             }
//             if (isCurrentStage) {
//               iconColor = colors.success;
//               textColor = 'black';
//             }

//             return (
//               <Link href={step.slug} key={index} sx={style.linkContainer}>
//                 <HStack
//                   onClick={() => handleChangeIndex(index)}
//                   sx={style.stepContainer}
//                 >
//                   {step.icon && (
//                     <Box
//                       sx={{
//                         background: 'white',
//                         _ltr: {
//                           left: '0',
//                           padding: isStageCompleted
//                             ? '2.5px 0px 0px 2.5px'
//                             : '6px',
//                         },
//                         _rtl: {
//                           right: '0',
//                           padding: isStageCompleted ? '2px 0px 0px 2px' : '6px',
//                         },
//                         top: '-2',
//                         color: iconColor,
//                         border: ' 1px solid #1A25501A',
//                         borderRadius: '50%',
//                         zIndex: 1,
//                       }}
//                     >
//                       <Icon
//                         name={isStageCompleted ? 'confirmTickStep' : step.icon}
//                         sx={
//                           !isStageCompleted
//                             ? style.stepIcon
//                             : style.stepCompletedIcon
//                         }
//                       />
//                     </Box>
//                   )}
//                   <Text
//                     as={'span'}
//                     sx={{
//                       fontsize: FontSizes.normal,
//                       fontWeight: isCurrentSelected
//                         ? FontWeights.bold
//                         : FontWeights.normal,
//                       color: textColor,
//                       flex: 1,
//                       w: '100%',
//                     }}
//                   >
//                     {step.name}
//                   </Text>
//                 </HStack>
//               </Link>
//             );
//           })}
//         </VStack>
//       </Box>
//     </Box>
//   );
// };
// export default Steps;
